import { Controller } from '@hotwired/stimulus'
import 'bootstrap/js/src/popover'

// Connects to data-controller="popover"
export default class extends Controller {
  connect() {
    $(this.element).popover({ html: true })
  }

  // Safari hack
  // https://github.com/reactstrap/reactstrap/issues/1428
  forceFocus() {
    if (this.element.dataset.trigger !== 'focus') return

    this.element.focus()
  }

  disconnect() {
    $(this.element).popover('dispose')
  }
}
